import React from 'react';

import { Dialog } from '@shared/components';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import useStyles from './style';

const noop = () => {};

const DownloadWarning = ({
  isOpen = false,
  onClose = noop,
  onConfirm = noop,
}) => {
  const classes = useStyles();

  //JSX
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={isOpen}
      onClose={onClose}
      classes={{
        paper: classes.downloadWarningDialog,
      }}
    >
      <Dialog.Title hasClose />
      <Dialog.Content>
        <div className='mt-1'>
          <Typography variant='h5' className='mb-3'>
            Confirm Action
          </Typography>
          <Typography variant='body1'>
            You are about to download an Excel file with all the limited
            extension data related to this account.
          </Typography>
          <Typography variant='body1' className='bold-font mt-2'>
            Please delete any rows you do not wish to modify. <br />
            You can only affect the following columns:
          </Typography>
          <Typography variant='body2' className='mt-2 ml-4'>
            1. Extension* <br />
            2. Extension Name* <br />
            3. Email Address* <br />
            4. Timezone <br />
            5. Emergency Address (Optional) <br />
            6. Customer Name (Optional - This is in the E911 address, does not
            rename the device) <br />
            7. Password and PIN (Optional - If entered, will activate an
            extension)
          </Typography>
          <Typography variant='body2' className='ml-4 mt-2'>
            *Required
          </Typography>
          <Typography variant='body1' className='bold-font mt-3'>
            Please note, this will change the user's notification email address,
            but also reset their notifications to defaults
          </Typography>
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          variant='contained'
          color='primary'
          className='mr-4 mb-4'
          onClick={onConfirm}
        >
          I Understand
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};
export default DownloadWarning;
